module.exports = __webpack_public_path__ + "static/img/nodata.e12f8e8d.png";